// Branded type utility
declare const __brand: unique symbol;
type Brand<T, B> = T & { [__brand]: B };

// Branded ID types
export type ConversationId = Brand<string, "ConversationId">;
export type DbConversationId = Brand<number, "DbConversationId">;
export type MessageId = Brand<string, "MessageId">;
export type UserId = Brand<number, "UserId">;
export type TagId = Brand<string, "TagId">;

// Constructor functions
export const ConversationId = (id: string) => id as ConversationId;
export const MessageId = (id: string) => id as MessageId;
export const TagId = (id: string) => id as TagId;
export const DbConversationId = (id: number) => id as DbConversationId;
export const UserId = (id: number) => id as UserId;
